export default {
  namespaced: true,
  state: {
    _isShopOpen: true,
    _showCurrency: false,
  },
  getters: {
    isOpen: state => state._isShopOpen,
    showCurrency: state => state._showCurrency, 
  },
  actions: {
    updateIsOpen({ commit }, payload) {
      commit("SET_IS_OPEN", payload);
    },
    updateShowCurrency({ commit }, payload) {
      commit("SET_SHOW_CURRENCY", payload);
    }
  },
  mutations: {
    SET_IS_OPEN(state, payload) {
      state._isShopOpen = payload;
    },
    SET_SHOW_CURRENCY(state, payload) {
      state._showCurrency = payload;
    }
  }
};
